<input
  autocomplete="off"
  id="findInput"
  class="toolbarField"
  title="Find"
  [placeholder]="'Find in document…'"
  data-l10n-id="find_input"
  name="search-input-field"
/>
